import { render, staticRenderFns } from "./barcode-show.vue?vue&type=template&id=e70d2dea&"
import script from "./barcode-show.vue?vue&type=script&lang=ts&"
export * from "./barcode-show.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports